import { Link } from 'react-router-dom';

interface WelfareCardProps {
  id: string;
  title: string;
  description: string;
  platform: string;
  discount: string;
  originalPrice: string;
  currentPrice: string;
  expiryDate: string;
  imageUrl: string;
  hot: boolean;
  category: string;
}

function WelfareCard({ id, title, description, platform, discount, originalPrice, currentPrice, expiryDate, imageUrl, hot }: WelfareCardProps) {
  return (
    <div className="bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300 group cursor-pointer h-full flex flex-col">
      <div className="relative h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 福利导航网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {hot && (
          <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-bold rounded-md">
            热门
          </span>
        )}
        <div className="absolute top-3 right-3 px-2.5 py-1 bg-background-900/70 backdrop-blur-sm text-white text-xs rounded-md">
          {platform}
        </div>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-semibold text-foreground-900 text-sm leading-snug mb-2 line-clamp-2">{title}</h3>
        <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{description}</p>
        <div className="mt-auto flex items-center justify-between">
          <div>
            <span className="text-lg font-bold text-primary-500">{currentPrice}</span>
            <span className="text-xs text-foreground-400 line-through ml-2">{originalPrice}</span>
          </div>
          <span className="text-xs bg-accent-100 text-accent-700 px-2 py-1 rounded-md font-medium">{discount}</span>
        </div>
        <div className="mt-3 pt-3 border-t border-background-100 flex items-center justify-between">
          <span className="text-xs text-foreground-400">
            <i className="ri-time-line mr-1"></i>有效期至 {expiryDate}
          </span>
          <Link
            to={`/article/${id}`}
            className="text-xs text-primary-500 font-medium hover:text-primary-600 flex items-center gap-1"
          >
            查看详情 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function WelfareCardGrid({ items }: { items: WelfareCardProps[] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
      {items.map((item) => (
        <WelfareCard key={item.id} {...item} />
      ))}
    </div>
  );
}